<script setup>
const router = useRouter()
const tab = useState('tab', () => 'season')

const props = defineProps({
  anime: {
    type: Object,
    default: () => {}
  }
})

// Порядок той самий, що й у розмітці вкладок
const availableTabs = computed(() =>
  [
    ['season', props.anime?.seasons],
    ['arches', props.anime?.arches],
    ['op', props.anime?.op],
    ['ed', props.anime?.ed]
  ]
    .filter(([, value]) => value != null)
    .map(([id]) => id)
)

// «Пов'язане» — головна вкладка: якщо воно в аніме є, відкрите завжди воно.
// Стан вкладки спільний на весь застосунок, тому без цього на нове аніме
// переїжджав би вибір з попереднього.
watch(
  availableTabs,
  (tabs) => {
    if (tabs.includes('season')) {
      tab.value = 'season'
      return
    }
    // Вкладки з минулого аніме тут може й не бути — падаємо на першу наявну
    if (!tabs.includes(tab.value)) tab.value = tabs[0] || 'ep'
  },
  { immediate: true }
)
</script>

<template>
  <!-- <div class="mt-[30px]">
    <div class="font-bold text-2xl">{{ $t('info') }}</div>
  </div> -->
  <div class="relative flex flex-nowrap mt-[15px] w-full overflow-x-auto tabs">
    <a
      class="text-xl transition-colors tab tab-bordered"
      v-if="anime?.seasons != null"
      @click="tab = 'season'"
      :class="{ 'tab-active': tab === 'season' }"
      >{{ $t('seasons') }}</a
    >
    <a
      class="text-xl transition-colors tab tab-bordered"
      v-if="anime?.arches != null"
      @click="tab = 'arches'"
      :class="{ 'tab-active': tab === 'arches' }"
      >{{ $t('arches') }}</a
    >
    <a
      class="text-xl transition-colors tab tab-bordered"
      v-if="anime?.op != null"
      @click="tab = 'op'"
      :class="{ 'tab-active': tab === 'op' }"
      >{{ $t('op') }}</a
    >
    <a
      class="text-xl transition-colors tab tab-bordered"
      v-if="anime?.ed != null"
      @click="tab = 'ed'"
      :class="{ 'tab-active': tab === 'ed' }"
      >{{ $t('ed') }}</a
    >
  </div>

  <div
    class="flex flex-col mt-[15px] w-[100%] showTab"
    v-if="tab === 'season'"
  >
    <span v-for="(season, ind) in anime?.seasons">
      {{ ind + 1 }}.
      <a
        class="shadow-md link"
        :href="season.url"
        >{{ season?.title }}</a
      >
      {{ season.text ? ' - ' + season.text : '' }}
    </span>
  </div>

  <div
    class="flex flex-col mt-[15px] w-[100%] showTab"
    v-if="tab === 'arches'"
  >
    <div v-html="anime?.arches.split('\\n').join('<br/>')"></div>
  </div>

  <div
    class="flex flex-wrap gap-[5px] mt-[15px] w-[100%] showTab"
    v-if="tab === 'op'"
  >
    <div v-for="(video, ind) in anime?.op">
      <div
        class="flex flex-wrap items-center gap-[20px] p-[1rem] lg:py-0 h-auto cursor-auto select-text btn"
      >
        <div>{{ video?.title }} ({{ video.episodes }})</div>
        <label
          v-if="video.url"
          :for="`modal-op-${ind}`"
          class="w-[24px] h-[24px] cursor-pointer"
        >
          <svg
            class="w-full h-full"
            width="32"
            height="32"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12 0C5.376 0 0 5.376 0 12s5.376 12 12 12s12-5.376 12-12S18.624 0 12 0zm0 19.104c-3.924 0-7.104-3.18-7.104-7.104S8.076 4.896 12 4.896s7.104 3.18 7.104 7.104s-3.18 7.104-7.104 7.104zm0-13.332c-3.432 0-6.228 2.796-6.228 6.228S8.568 18.228 12 18.228s6.228-2.796 6.228-6.228S15.432 5.772 12 5.772zM9.684 15.54V8.46L15.816 12l-6.132 3.54z"
            />
          </svg>
        </label>
        <a
          v-if="video.apple"
          :href="video.apple"
          class="w-[24px] h-[24px] cursor-pointer"
          target="_blank"
        >
          <svg
            class="w-full h-full"
            width="32"
            height="32"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M23.994 6.124a9.23 9.23 0 0 0-.24-2.19c-.317-1.31-1.062-2.31-2.18-3.043a5.022 5.022 0 0 0-1.877-.726a10.496 10.496 0 0 0-1.564-.15c-.04-.003-.083-.01-.124-.013H5.986c-.152.01-.303.017-.455.026c-.747.043-1.49.123-2.193.4c-1.336.53-2.3 1.452-2.865 2.78c-.192.448-.292.925-.363 1.408a10.61 10.61 0 0 0-.1 1.18c0 .032-.007.062-.01.093v12.223c.01.14.017.283.027.424c.05.815.154 1.624.497 2.373c.65 1.42 1.738 2.353 3.234 2.801c.42.127.856.187 1.293.228c.555.053 1.11.06 1.667.06h11.03a12.5 12.5 0 0 0 1.57-.1c.822-.106 1.596-.35 2.295-.81a5.046 5.046 0 0 0 1.88-2.207c.186-.42.293-.87.37-1.324c.113-.675.138-1.358.137-2.04c-.002-3.8 0-7.595-.003-11.393zm-6.423 3.99v5.712c0 .417-.058.827-.244 1.206c-.29.59-.76.962-1.388 1.14c-.35.1-.706.157-1.07.173c-.95.045-1.773-.6-1.943-1.536a1.88 1.88 0 0 1 1.038-2.022c.323-.16.67-.25 1.018-.324c.378-.082.758-.153 1.134-.24c.274-.063.457-.23.51-.516a.904.904 0 0 0 .02-.193c0-1.815 0-3.63-.002-5.443a.725.725 0 0 0-.026-.185c-.04-.15-.15-.243-.304-.234c-.16.01-.318.035-.475.066c-.76.15-1.52.303-2.28.456l-2.325.47l-1.374.278c-.016.003-.032.01-.048.013c-.277.077-.377.203-.39.49c-.002.042 0 .086 0 .13c-.002 2.602 0 5.204-.003 7.805c0 .42-.047.836-.215 1.227c-.278.64-.77 1.04-1.434 1.233c-.35.1-.71.16-1.075.172c-.96.036-1.755-.6-1.92-1.544c-.14-.812.23-1.685 1.154-2.075c.357-.15.73-.232 1.108-.31c.287-.06.575-.116.86-.177c.383-.083.583-.323.6-.714v-.15c0-2.96 0-5.922.002-8.882c0-.123.013-.25.042-.37c.07-.285.273-.448.546-.518c.255-.066.515-.112.774-.165c.733-.15 1.466-.296 2.2-.444l2.27-.46c.67-.134 1.34-.27 2.01-.403c.22-.043.442-.088.663-.106c.31-.025.523.17.554.482c.008.073.012.148.012.223c.002 1.91.002 3.822 0 5.732z"
            />
          </svg>
        </a>
        <a
          v-if="video.spotify"
          :href="video.spotify"
          class="w-[24px] h-[24px] cursor-pointer"
          target="_blank"
        >
          <svg
            class="w-full h-full"
            width="32"
            height="32"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12s12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24c-2.82-1.74-6.36-2.101-10.561-1.141c-.418.122-.779-.179-.899-.539c-.12-.421.18-.78.54-.9c4.56-1.021 8.52-.6 11.64 1.32c.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3c-3.239-1.98-8.159-2.58-11.939-1.38c-.479.12-1.02-.12-1.14-.6c-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721c-.18-.601.18-1.2.72-1.381c4.26-1.26 11.28-1.02 15.721 1.621c.539.3.719 1.02.419 1.56c-.299.421-1.02.599-1.559.3z"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>

  <div
    class="flex flex-wrap gap-[5px] mt-[15px] w-[100%] showTab"
    v-if="tab === 'ed'"
  >
    <div v-for="(video, ind) in anime?.ed">
      <div
        class="flex flex-wrap items-center gap-[20px] p-[1rem] lg:py-0 h-auto cursor-auto select-text btn"
      >
        <div>{{ video?.title }} ({{ video.episodes }})</div>
        <label
          v-if="video.url"
          :for="`modal-ep-${ind}`"
          class="w-[24px] h-[24px] cursor-pointer"
        >
          <svg
            class="w-full h-full"
            width="32"
            height="32"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12 0C5.376 0 0 5.376 0 12s5.376 12 12 12s12-5.376 12-12S18.624 0 12 0zm0 19.104c-3.924 0-7.104-3.18-7.104-7.104S8.076 4.896 12 4.896s7.104 3.18 7.104 7.104s-3.18 7.104-7.104 7.104zm0-13.332c-3.432 0-6.228 2.796-6.228 6.228S8.568 18.228 12 18.228s6.228-2.796 6.228-6.228S15.432 5.772 12 5.772zM9.684 15.54V8.46L15.816 12l-6.132 3.54z"
            />
          </svg>
        </label>
        <a
          v-if="video.apple"
          :href="video.apple"
          class="w-[24px] h-[24px] cursor-pointer"
          target="_blank"
        >
          <svg
            class="w-full h-full"
            width="32"
            height="32"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M23.994 6.124a9.23 9.23 0 0 0-.24-2.19c-.317-1.31-1.062-2.31-2.18-3.043a5.022 5.022 0 0 0-1.877-.726a10.496 10.496 0 0 0-1.564-.15c-.04-.003-.083-.01-.124-.013H5.986c-.152.01-.303.017-.455.026c-.747.043-1.49.123-2.193.4c-1.336.53-2.3 1.452-2.865 2.78c-.192.448-.292.925-.363 1.408a10.61 10.61 0 0 0-.1 1.18c0 .032-.007.062-.01.093v12.223c.01.14.017.283.027.424c.05.815.154 1.624.497 2.373c.65 1.42 1.738 2.353 3.234 2.801c.42.127.856.187 1.293.228c.555.053 1.11.06 1.667.06h11.03a12.5 12.5 0 0 0 1.57-.1c.822-.106 1.596-.35 2.295-.81a5.046 5.046 0 0 0 1.88-2.207c.186-.42.293-.87.37-1.324c.113-.675.138-1.358.137-2.04c-.002-3.8 0-7.595-.003-11.393zm-6.423 3.99v5.712c0 .417-.058.827-.244 1.206c-.29.59-.76.962-1.388 1.14c-.35.1-.706.157-1.07.173c-.95.045-1.773-.6-1.943-1.536a1.88 1.88 0 0 1 1.038-2.022c.323-.16.67-.25 1.018-.324c.378-.082.758-.153 1.134-.24c.274-.063.457-.23.51-.516a.904.904 0 0 0 .02-.193c0-1.815 0-3.63-.002-5.443a.725.725 0 0 0-.026-.185c-.04-.15-.15-.243-.304-.234c-.16.01-.318.035-.475.066c-.76.15-1.52.303-2.28.456l-2.325.47l-1.374.278c-.016.003-.032.01-.048.013c-.277.077-.377.203-.39.49c-.002.042 0 .086 0 .13c-.002 2.602 0 5.204-.003 7.805c0 .42-.047.836-.215 1.227c-.278.64-.77 1.04-1.434 1.233c-.35.1-.71.16-1.075.172c-.96.036-1.755-.6-1.92-1.544c-.14-.812.23-1.685 1.154-2.075c.357-.15.73-.232 1.108-.31c.287-.06.575-.116.86-.177c.383-.083.583-.323.6-.714v-.15c0-2.96 0-5.922.002-8.882c0-.123.013-.25.042-.37c.07-.285.273-.448.546-.518c.255-.066.515-.112.774-.165c.733-.15 1.466-.296 2.2-.444l2.27-.46c.67-.134 1.34-.27 2.01-.403c.22-.043.442-.088.663-.106c.31-.025.523.17.554.482c.008.073.012.148.012.223c.002 1.91.002 3.822 0 5.732z"
            />
          </svg>
        </a>
        <a
          v-if="video.spotify"
          :href="video.spotify"
          class="w-[24px] h-[24px] cursor-pointer"
          target="_blank"
        >
          <svg
            class="w-full h-full"
            width="32"
            height="32"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12s12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24c-2.82-1.74-6.36-2.101-10.561-1.141c-.418.122-.779-.179-.899-.539c-.12-.421.18-.78.54-.9c4.56-1.021 8.52-.6 11.64 1.32c.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3c-3.239-1.98-8.159-2.58-11.939-1.38c-.479.12-1.02-.12-1.14-.6c-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721c-.18-.601.18-1.2.72-1.381c4.26-1.26 11.28-1.02 15.721 1.621c.539.3.719 1.02.419 1.56c-.299.421-1.02.599-1.559.3z"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>

  <!-- <div
    class="flex flex-wrap gap-[5px] mt-[15px] w-[100%] text-neutral-content showTab"
    v-if="tab == 'mark'"
  >
    <div
      v-for="(ep, ind) in filterMarks"
      class="bg-neutral p-[10px] rounded-md"
    >
      <div class="font-bold text-lg">
        {{ ep.title }}
      </div>
      <div
        v-for="mark in anime?.timemarks.filter((a) => a.epId == ep.id)"
        class="flex items-center"
      >
        <div class="">
          {{ mark.title }} - {{ mark.time }}
          {{ mark.author ? `(${mark.author})` : '' }}
        </div>
      </div>
    </div>
  </div> -->

  <div
    v-if="tab === 'op'"
    v-for="(video, ind) in anime?.op"
    class="bg-black rounded-md w-full overflow-hidden"
  >
    <template v-if="video.url">
      <input
        type="checkbox"
        :id="`modal-op-${ind}`"
        class="modal-toggle"
      />
      <label
        :for="`modal-op-${ind}`"
        class="cursor-pointer modal"
      >
        <label
          class="relative flex justify-center items-center p-0 min-w-[60vw] min-h-[60vh] aspect-video modal-box"
          for=""
        >
          <iframe
            width="100%"
            height="auto"
            style="aspect-ratio: 16 / 9"
            :src="`https://www.youtube.com/embed/${video.url.split('?v=')[1]}`"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </label>
      </label>
    </template>
  </div>

  <div
    v-if="tab === 'ed'"
    v-for="(video, ind) in anime?.ed"
    class="bg-black rounded-md w-full overflow-hidden"
  >
    <template v-if="video.url">
      <input
        type="checkbox"
        :id="`modal-ep-${ind}`"
        class="modal-toggle"
      />
      <label
        :for="`modal-ep-${ind}`"
        class="cursor-pointer modal"
      >
        <label
          class="relative flex justify-center items-center p-0 min-w-[60vw] min-h-[60vh] modal-box"
          for=""
        >
          <iframe
            width="100%"
            height="auto"
            style="aspect-ratio: 16 / 9"
            :src="`https://www.youtube.com/embed/${video.url.split('?v=')[1]}`"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </label>
      </label>
    </template>
  </div>
</template>

<style>
.showTab {
  animation: animTab 0.25s ease-out;
}

.tab.tab-active {
  border-color: hsla(var(--p) / 1);
}

.info-anim-enter-active,
.info-anim-leave-active {
  position: relative;
  left: 0;
  transition: 0.5s ease;
}

.info-anim-enter-from,
.info-anim-leave-to {
  left: 15px;
  opacity: 0;
}

@keyframes animTab {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.tabs::after {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background: hsla(var(--bc) / 1);
  margin-top: -1px;
}
</style>
